// extracted by mini-css-extract-plugin
export default {"imagebg":"eljardin_imagebg__uAPHk"};